module.exports = __webpack_public_path__ + "svg_80x80/unreal.c4cb79.svg";